import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { YesNo } from 'interfaces';

export type Grade = {
  grade_id?: number; // 등급 idx
  grade_name?: string; // 등급명
  grade_description?: string; // 등급 설명
  grade_condition_month?: number; // 등급조건(개월)
  grade_condition_amount?: number; // 등급금액
  automatic_grade?: (typeof YesNo)[keyof typeof YesNo]; // 자동등업여부
  grade_date?: number; // 등급유지기간
  is_enable?: (typeof YesNo)[keyof typeof YesNo]; // 사용여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
  coupon?: { [key: string]: Record<string, any> }; // 쿠폰
  grade_reason?: string; // 등업변경사유
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Grade
   * --
   */
  getGrades: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_GRADE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Grade
   * --
   */
  getGrade: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_GRADE, { grade_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Grade
   * --
   */
  createGrade: async (body: Grade) => {
    try {
      const res = await $http.post(APIConstant.CREATE_GRADE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Grade
   * --
   */
  updateGrade: async (body: Grade) => {
    try {
      const { grade_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_GRADE, {
        grade_id: grade_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Grade
   * --
   */
  deleteGrade: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_GRADE, {
        grade_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
